import {t} from './i18n.js';
import { textDocument, fileDocument } from './document.js';
import { sha256 } from './storage.js';
import {policy} from './policy.js';
export const adapters = [
  {id:'epub',accept:'.epub',async read(file,id){const {epubDocument}=await import('./epub-import.js');return (await epubDocument(file,id)).book;}},
  {id:'pdf',accept:'.pdf',async read(file,id,title){return policy('importBook',{id,title,kind:'pdf',language:'en',originalName:file.name});}},
  {id:'markdown',accept:'.md,.markdown',async read(file,id,title){return {...await fileDocument(file,{id,title,markdown:true}),imported:true,originalName:file.name};}},
  {id:'text',accept:'.txt,text/plain',async read(file,id,title){return {...await fileDocument(file,{id,title,markdown:false}),imported:true,originalName:file.name};}},
];
export const acceptedFiles=adapters.map(a=>a.accept).join(',');
export async function importFile(file){
  const header=new TextDecoder().decode(await file.slice(0,12).arrayBuffer());
  const plan=await policy('importFile',{name:file.name,size:file.size,header});
  if(plan.error)throw Error(t(plan.error,{value1:file.name}));
  const id='import-'+await sha256(await file.arrayBuffer());
  return adapters.find(adapter=>adapter.id===plan.format).read(file,id,plan.title);
}
export async function importText(source,title){
  const id='import-'+await sha256(new TextEncoder().encode(source));
  const name=await policy('importTitle',{source,title,fallback:t('ui-untitled-reading')});
  return {...await textDocument(source,{id,title:name}),imported:true,originalName:'reading.md'};
}
